import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Login from './pages/Login';
import SignUp from './pages/SignUp';
import AdminPage from './pages/AdminPage';
import BusinessPage from './pages/BusinessPage';
import AddCocktailPage from './pages/AddCocktailPage';
import CreateQRCodePage from './pages/CreateQRCodePage';
import MenuPage from './pages/MenuPage';
import Contact from './pages/Contact';
import SeeMessagesPage from './pages/SeeMessagesPage';
import LandingPage from './pages/LandingPage';
import ManageBarsPage from './pages/ManageBarsPage';
import BarCocktailsPage from './pages/BarCocktailsPage';
import EditCocktailPage from './pages/EditCocktailPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/business" element={<BusinessPage />} />
        <Route path="/add-cocktail" element={<AddCocktailPage />} />
        <Route path="/create-qr" element={<CreateQRCodePage />} />
        <Route path="/menu/:barName" element={<MenuPage />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/messages" element={<SeeMessagesPage />} />
        <Route path="/manage-bars" element={<ManageBarsPage />} />
        <Route path="/manage-bars/:barName" element={<BarCocktailsPage />} />
        <Route path="/edit-cocktail/:cocktailId" element={<EditCocktailPage />} />
      </Routes>
    </Router>
  );
}

export default App;